export default "__VITE_ASSET__aKtATLz$__"